<template>
  <div v-if="apps && apps.length > 0" class="table-page">
    <!--过滤栏 -->
    <search-wrapper>
      <a-row :gutter="40">
        <a-col :span="7" :xl="7">
          <a-form-item label="应用编号">
            <a-select :allowClear="false" defaultValue="" v-model="targetAppId">
              <a-select-option value="">全部</a-select-option>
              <a-select-option :key="app.appId" :value="app.appId" v-for="app in apps">
                {{ app.appId + ' | ' + app.appName  }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <div class="op-div">
          <a-col :span="6">
            <a-form-item class="operation-group">
              <a-button icon="search" @click="handleSearch">查询</a-button>
              <a-button class="reset-btn" icon="sync" @click="resetSearch">重置</a-button>
            </a-form-item>
          </a-col>
        </div>

      </a-row>
    </search-wrapper>
    <!--昨日数据 -->
    <!-- <b style="font-size: 14px">昨日关键指标</b> -->
    <div style="margin-top: 20px; backgroundColor: #fff; padding: 28px 2px; box-shadow: @box-shadow-base;">
      <a-row >
        <a-col :span="6" style="border-right:1px #e9e9e9 solid">
          <span>
            <p class="userBind__yesterday__statistics__title">新绑定人数</p>
            <div class="userBind__yesterday__statistics__value">{{yesterdayIncreaseQuantity}}</div>
          </span>
        </a-col>
        <a-col :span="6" style="border-right:1px #e9e9e9 solid">
          <span>
            <p class="userBind__yesterday__statistics__title">解绑人数</p>
            <div class="userBind__yesterday__statistics__value">{{yesterdayDecreaseQuantity}}</div>
          </span>
        </a-col>
        <a-col :span="6" style="border-right:1px #e9e9e9 solid">
          <span>
            <p class="userBind__yesterday__statistics__title">净绑定人数</p>
            <div class="userBind__yesterday__statistics__value">{{yesterdayRealIncreaseQuantity}}</div>
          </span>
        </a-col>
        <a-col>
          <span>
            <p class="userBind__yesterday__statistics__title">累积绑定人数</p>
            <div class="userBind__yesterday__statistics__value">{{yesterdayTotalQuantity}}</div>
          </span>
        </a-col>
      </a-row>
    </div>

    <!-- 图标头部 日期，日期变更影响当前页全部 -->
    <div style="margin-top: 24px;width: 100%; background-color: #fff; border-radius: 2px;">
      <div class="chart-header">
        <span style="font-size: 16px; font-weight:600">趋势图</span>
        <a-row>
          <a-col :span="colSpan">
            <a-radio-group style="width: 100%" @change="handleChartTypeChange" defaultValue="IncreaseQuantity">
              <a-radio-button value="IncreaseQuantity">
                新绑定
              </a-radio-button>
              <a-radio-button value="DecreaseQuantity">
                解绑
              </a-radio-button>
              <a-radio-button  value="RealIncreaseQuantity">
                净绑定
              </a-radio-button>
              <a-radio-button  value="TotalQuantity">
                累积绑定
              </a-radio-button>
            </a-radio-group>
          </a-col>
          <a-col :span="colSpan">
            <a-range-picker style="margin-left: 20px;width: 100%" :allowClear="false" @change="handleDateRangeChange" v-model="dateRange" format="YYYY-MM-DD">
              <a-icon slot="suffixIcon" type="calendar" />
            </a-range-picker>
          </a-col>
          <a-col :span="downloadSpan">
            <a class="userBind__download" @click="downloadExcel">
              <a-icon type="download" />
              下载表格
            </a>
          </a-col>
        </a-row>
      </div>
          <!--图表 -->
      <div style="margin-top: 12px;height: 377px">
        <div id="userBindChart" class="chart-page__chart"></div>
      </div>
    </div>

    <!-- 分页表格 -->
    <global-table
      ref="table"
      :columns="columns"
      :dataRender="loadData"
      style="height:700px;margin-top: 24px"
      filled
    />
  </div>
  <a-empty v-else style="height: 100%"></a-empty>
</template>

<script>
import SearchWrapper from '@/components/SearchWrapper';
import GlobalTable from '@/components/GlobalTable';
import moment from 'moment';
import { listUserBindDailyStatisticsByPage, listUserBindDailyStatistics, getAllApp } from '@/services/modules/data';
import {
  Button, Row, Col, Select, Form, Card, Radio, DatePicker, Empty,
} from 'ant-design-vue';
import debounce from 'lodash/debounce';
import { setUserBindChartOption } from './set-chart-option';

const echarts = require('echarts/lib/echarts');
require('echarts/lib/chart/line');
require('echarts/lib/component/legend');
require('echarts/lib/component/tooltip');

export default {
  name: 'UserBind',
  components: {
    SearchWrapper,
    GlobalTable,
    'a-row': Row,
    'a-col': Col,
    'a-button': Button,
    'a-select': Select,
    'a-select-option': Select.Option,
    'a-form-item': Form.Item,
    'a-card': Card,
    'a-radio-group': Radio.Group,
    'a-radio-button': Radio.Button,
    'a-range-picker': DatePicker.RangePicker,
    'a-empty': Empty,
  },
  data() {
    return {
      apps: [],
      targetAppId: '',
      yesterdayIncreaseQuantity: 0,
      yesterdayDecreaseQuantity: 0,
      yesterdayRealIncreaseQuantity: 0,
      yesterdayTotalQuantity: 0,
      chartType: 'IncreaseQuantity',
      dateRange: this.getInitDateRange(),
      userBindChart: null,
      chartData: [],
      fullWidth: document.documentElement.clientWidth,
    };
  },
  created() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  mounted() {
    getAllApp().then((res) => {
      if (res && res.result && res.result.length > 0) {
        this.apps = res.result;
        this.requestYesterday();
        this.setChart();
      }
    });
  },
  computed: {
    colSpan() {
      if (this.fullWidth < 1120) {
        return 10;
      }
      if (this.fullWidth < 1410) {
        return 10;
      }
      return 10;
    },
    offsetSpan() {
      if (this.fullWidth < 1410) {
        return 0;
      }
      return 6;
    },
    downloadSpan() {
      if (this.fullWidth < 1120) {
        return 4;
      }
      if (this.fullWidth < 1410) {
        return 4;
      }
      return 4;
    },
    columns() {
      return [
        {
          title: '时间',
          key: 'statisticsDate',
          align: 'left',
          minWidth: 125,
        },
        {
          title: '新绑定人数',
          key: 'increaseQuantity',
          align: 'left',
          minWidth: 125,
        },
        {
          title: '取消绑定人数',
          key: 'decreaseQuantity',
          align: 'left',
          minWidth: 125,
        },
        {
          title: '净绑定人数',
          key: 'realIncreaseQuantity',
          align: 'left',
          minWidth: 125,
        },
        {
          title: '累积绑定人数',
          key: 'totalQuantity',
          align: 'left',
          minWidth: 125,
        },
      ];
    },
    defaultQueryParams() {
      return {
        appId: this.targetAppId,
        beginDate: this.dateRange[0].format('YYYY-MM-DD'),
        endDate: this.dateRange[1].format('YYYY-MM-DD'),
      };
    },
  },
  methods: {
    setChart() {
      let name = '累积绑定人数';
      if (this.chartType === 'IncreaseQuantity') {
        name = '新绑定人数';
      } else if (this.chartType === 'DecreaseQuantity') {
        name = '解绑人数';
      } else if (this.chartType === 'RealIncreaseQuantity') {
        name = '净绑定人数';
      } else {
        name = '累积绑定人数';
      }
      if (this.chartData && this.chartData.length > 0) {
        this.userBindChart = echarts.init(document.getElementById('userBindChart'));
        this.userBindChart.setOption(setUserBindChartOption(this.chartData, this.chartType, name));
      } else {
        this.requestList().then((res) => {
          if (res && res.result) {
            this.chartData = res.result.reverse();
            this.userBindChart = echarts.init(document.getElementById('userBindChart'));
            this.userBindChart.setOption(setUserBindChartOption(this.chartData, this.chartType, name));
          }
        });
      }
    },
    resizeChart: debounce(function resizeChart() {
      if (this.userBindChart) {
        this.userBindChart.resize();
      }
    }, 200),
    loadData(parameter) {
      return listUserBindDailyStatisticsByPage({ ...parameter, ...this.defaultQueryParams });
    },
    requestList() {
      return listUserBindDailyStatistics(this.defaultQueryParams);
    },
    requestYesterday() {
      const yesterdayParam = {
        beginDate: moment().startOf('day').subtract(1, 'days').format('YYYY-MM-DD'),
        endDate: moment().startOf('day').subtract(1, 'days').format('YYYY-MM-DD'),
        appId: this.targetAppId,
      };
      listUserBindDailyStatistics(yesterdayParam).then((res) => {
        if (res && res.result && res.result.length > 0) {
          this.yesterdayIncreaseQuantity = res.result[0].increaseQuantity || 0;
          this.yesterdayDecreaseQuantity = res.result[0].decreaseQuantity || 0;
          this.yesterdayRealIncreaseQuantity = res.result[0].realIncreaseQuantity || 0;
          this.yesterdayTotalQuantity = res.result[0].totalQuantity || 0;
        }
      });
    },
    handleChartTypeChange(e) {
      this.chartType = e.target.value;
      this.setChart();
    },
    handleDateRangeChange(dates) {
      this.dateRange = dates;
      this.handleSearch();
    },
    handleSearch() {
      this.$refs.table.refresh(true);
      this.chartData = [];
      this.requestYesterday();
      this.setChart();
    },
    resetSearch() {
      this.targetAppId = '';
      this.dateRange = this.getInitDateRange();
      this.handleSearch();
    },
    getInitDateRange() {
      const defaultSelectDate = {
        startDate: moment().startOf('day').subtract(30, 'days'),
        endDate: moment().startOf('day').subtract(1, 'days'),
      };
      return [defaultSelectDate.startDate, defaultSelectDate.endDate];
    },
    downloadExcel() {
      const url = `${process.env.VUE_APP_API_BASE_URL}/export/exportUserBindXls`;
      const params = this.defaultQueryParams;
      const tempForm = document.createElement('form');
      tempForm.action = url;
      tempForm.target = '_self';
      tempForm.method = 'post';
      tempForm.style.display = 'none';
      Object.keys(params).forEach(key => {
        if (!(params[key] === '' || params[key] === undefined)) {
          const opt = document.createElement('textarea');
          opt.name = key;
          opt.value = params[key];
          tempForm.appendChild(opt);
        }
      });
      document.body.appendChild(tempForm);
      // 提交数据
      tempForm.submit();
    },
    handleResize() {
      this.fullWidth = document.documentElement.clientWidth;
    },
  },
};
</script>

<style lang="less" scoped>
  .table-page {
    .op-div {
      /deep/ .ant-col-6 {
        width: auto;
      }
    }
  }
  .chart-header {
    display: flex;
    justify-content: space-between;
    padding: 20px 20px 0 38px;
  }
  .chart-page {
    height: 100%;
    &__chart {
      height: 300px;
    }
  }
  .userBind__yesterday__statistics__title{
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
    line-height: 20px;
    text-align: center;
  }
  .userBind__yesterday__statistics__value{
    font-size: 28px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    line-height: 40px;
    text-align: center;
  }
  .userBind__download {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #178FFF;
    line-height: 20px;
    float: right;
    margin-top: 6px;
  }
</style>
